import { ProposalStatus, VoteOption } from '@/types/governance'

export function formatProposalStatus(status: ProposalStatus): string {
  const statusLabels: Record<ProposalStatus, string> = {
    [ProposalStatus.Unspecified]: 'Unspecified',
    [ProposalStatus.DepositPeriod]: 'Deposit Period',
    [ProposalStatus.VotingPeriod]: 'Voting',
    [ProposalStatus.Passed]: 'Passed',
    [ProposalStatus.Rejected]: 'Rejected',
    [ProposalStatus.Failed]: 'Failed',
    [ProposalStatus.Canceled]: 'Canceled',
  }
  return statusLabels[status] ?? status
}

type ProposalStatusVariant =
  | 'default'
  | 'accent'
  | 'success'
  | 'error'
  | 'secondary'
  | 'destructive'
  | 'outline'

export function getProposalStatusVariant(
  status: ProposalStatus,
): ProposalStatusVariant {
  const variantMap: Record<ProposalStatus, ProposalStatusVariant> = {
    [ProposalStatus.Unspecified]: 'outline',
    [ProposalStatus.DepositPeriod]: 'secondary',
    [ProposalStatus.VotingPeriod]: 'accent',
    [ProposalStatus.Passed]: 'success',
    [ProposalStatus.Rejected]: 'error',
    [ProposalStatus.Failed]: 'destructive',
    [ProposalStatus.Canceled]: 'outline',
  }
  return variantMap[status] ?? 'default'
}

export function formatVoteOption(option: VoteOption): string {
  const optionLabels: Record<VoteOption, string> = {
    [VoteOption.Unspecified]: 'Unspecified',
    [VoteOption.Yes]: 'Yes',
    [VoteOption.Abstain]: 'Abstain',
    [VoteOption.No]: 'No',
    [VoteOption.NoWithVeto]: 'No with Veto',
  }
  return optionLabels[option] ?? option
}

export function canVoteOnProposal(status: ProposalStatus): boolean {
  return status === ProposalStatus.VotingPeriod
}
